import http from "@/settings/apiSettings"

class DrepturiUtilizatoriDataService {
    // get(): Promise<any> {
    //   return http.clientAuth.get("/AUTH_DrepturiUtilizatori/GetDrepturiUtilizatori");
    // }

    // getByUserId(userId: string): Promise<any> {
    // return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetDrepturiUtilizatori/${userId}`);
    // }

    save(data: any): Promise<any> {
      return http.clientAuth.post("/AUTH_DrepturiUtilizatori/AddDrepturi", data);
    }
    saveRol(data: any): Promise<any> {
      return http.clientAuth.post("/AUTH_DrepturiUtilizatori/AddRolToUser", data);
    }

    getAgenti(userId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetAgenti/${userId}`);
    }

    getTipuri(userId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetTipuriDocumente/${userId}`);
    }

    getGestiuni(userId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetGestiuni/${userId}`);
    }

    getMeniuri(userId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetMeniuri/${userId}`);
    }
    
    getMeniuriCustom(userId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetMeniuri/${userId}`);
    }

    getCategoriiComenzi(userId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetCategoriiComenzi/${userId}`);
    }
    
    getCategoriiProduse(userId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetPRO_Categorii/${userId}`);
    }

    getCapitole(userId: string): Promise<any> {
      return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetDOC_Capitole/${userId}`);
    }

    getCategoriiDocumente(userId: string): Promise<any> {
      return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetDOC_Categorii/${userId}`);
    }

    updateDrepturi(id: string, data: { Citeste?: boolean; Modifica?: boolean; Sterge?: boolean; }) {
      return http.clientAuth.patch(`/AUTH_DrepturiUtilizatori/UpdateDrepturi/${id}`, data);
    }
    
    getRoluri(userId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiUtilizatori/GetRoluri/${userId}`);
    }
    
    delete(userId: string, agentId: string, rightId?: string | null): Promise<any> {
    return http.clientAuth.delete(`/AUTH_DrepturiUtilizatori/DeleteDrepturi`, {
    data: {
      userId,
      agentId,
      rightId,
      tip: 'AGENT'
    }
    
  });
    }
    
    deleteRoluriUtilizatori(userId: string, rolId: string, rightId?: string | null): Promise<any> {
      return http.clientAuth.delete(`/AUTH_DrepturiUtilizatori/DeleteRoluriUtilizatori`, {
      data: {
        userId,
        rolId,
        rightId,
        //tip: 'AGENT'
    }
    
  });
    }


}

export default new DrepturiUtilizatoriDataService();